import { Controller } from "@hotwired/stimulus"

// Fallback polling for when Turbo Streams (ActionCable/Redis) is unavailable
export default class extends Controller {
  static values = {
    documentId: Number,
    candidateId: Number,
    pollingInterval: { type: Number, default: 5000 },
    slowPollingInterval: { type: Number, default: 60000 },
    slowDownAfter: { type: Number, default: 60000 }
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    // Check if we're in a pending/processing state that needs polling
    const content = this.element.querySelector('[id^="candidate_document_review_"]')
    if (this.needsPolling(content)) {
      this.pollingStartedAt = Date.now()
      this.currentInterval = this.pollingIntervalValue
      this.pollTimer = setInterval(() => this.checkStatus(), this.currentInterval)
    }
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
  }

  switchToSlowPolling() {
    if (this.currentInterval === this.slowPollingIntervalValue) return

    this.stopPolling()
    this.currentInterval = this.slowPollingIntervalValue
    this.pollTimer = setInterval(() => this.checkStatus(), this.currentInterval)
  }

  needsPolling(content) {
    if (!content) return false
    // Check if the content contains processing/pending indicators
    const text = content.textContent || ''
    return text.includes('Processing') ||
           text.includes('Procesando') ||
           text.includes('Queued') ||
           text.includes('En cola')
  }

  async checkStatus() {
    try {
      // Switch to slow polling after the configured time (default 1 minute)
      const elapsed = Date.now() - this.pollingStartedAt
      if (elapsed >= this.slowDownAfterValue) {
        this.switchToSlowPolling()
      }

      const response = await fetch(
        `/candidates/${this.candidateIdValue}/documents/${this.documentIdValue}/review`,
        {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      )

      if (response.ok) {
        const html = await response.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const newContent = doc.querySelector('[id^="candidate_document_review_"]')

        if (newContent) {
          const currentContent = this.element.querySelector('[id^="candidate_document_review_"]')
          if (currentContent) {
            currentContent.innerHTML = newContent.innerHTML
          }

          // Stop polling if no longer processing
          if (!this.needsPolling(newContent)) {
            this.stopPolling()
          }
        }
      }
    } catch (error) {
      console.warn('Document review polling error:', error)
    }
  }
}
